// extracted by mini-css-extract-plugin
module.exports = {"container":"PanelContainer_container__12MNC","dynamic":"PanelContainer_dynamic__1-Gue","newToken":"PanelContainer_newToken__3Scll"};